module.exports = __webpack_public_path__ + "img/42.f92e2024.jpg";